// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"FHhik","properties":"oAJmG","value":"ZBYFr","icon":"tKBST"};